import {
	selectIsDateRangeEnabled,
	selectThisSlice
} from '../selectors';
import { thunkSetType, thunkSetEnabled } from './thunks.core';

const thunkToggleDateRange = ({ preventUrlWrite = false, onComplete = () => {} }) => (
	dispatch,
	getState
) => {
	const slice = selectThisSlice(getState());
	const enable = !selectIsDateRangeEnabled(slice);
  dispatch(thunkSetEnabled(enable, { preventUrlWrite }));
  onComplete({ shouldCloseDropdown: true });
};

const thunkSetDateRangeTypeFromList = ({
	type,
	autoFilter,
	preventUrlWrite = false
}) => dispatch => {
	dispatch(thunkSetType(type));
	if (autoFilter) {
    dispatch(thunkSetEnabled(true, { preventUrlWrite }));
	} else {
    dispatch(thunkSetEnabled(false, { preventUrlWrite }));
	}
};

const thunkFilterDateRange = ({ preventUrlWrite = false } = {}) => dispatch => {
	dispatch(thunkSetEnabled(true, { preventUrlWrite }));
};

export {
	thunkToggleDateRange,
	thunkSetDateRangeTypeFromList,
	thunkFilterDateRange
};

export default {
	thunkToggleDateRange,
	thunkSetDateRangeTypeFromList,
	thunkFilterDateRange
};
